import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
export { MatDialogRef };

@Component({
  selector: 'modal-window',
  templateUrl: './modal-window-base.component.html',
  styleUrls: ['./modal-window.component.scss']
})
export class ModalWindowBaseComponent {
  public moda_window_ref: MatDialogRef<any> = inject(MatDialogRef);
  protected _defaults = {
    dialog_data: {
        title: 'Mensaje del sistema',
        body: 'Mensaje de prueba',
        icon: 'info'
    }
  }

  // ===========================================================================
  // ---------------------------------------------------------------------------
  constructor() {}

  // ---------------------------------------------------------------------------
  close(): void {
    this.moda_window_ref.close();
  }

  // ---------------------------------------------------------------------------
  closeAndReturn(return_data: any): void {
    this.moda_window_ref.close(return_data);
  }


}
